export enum PlanFileType {
  TRIMBLE_GFX = 'trimbleGfxTmx',
  TRIMBLE_CFX = 'trimbleCfx',
  TOPCON = 'topcon',
  SHP = 'shpFile'
}
